import type { ClaimValueBreakdown } from "@hp/types";
import { claimValueParts } from "../../lib/claimValue";
import { formatINR, formatINRRange } from "../../lib/format";

interface ClaimValueTableCellsProps {
  valueLow: number;
  valueHigh: number;
  breakdown?: ClaimValueBreakdown | null;
}

/** Three table cells: principal, LPS, total — for portfolio claim rows. */
export function ClaimValueTableCells({ valueLow, valueHigh, breakdown }: ClaimValueTableCellsProps) {
  const parts = claimValueParts(valueLow, valueHigh, breakdown);
  const hasCarrying = parts.carryingHigh > 0 || parts.carryingLow > 0;
  const hasPrincipal = parts.principalHigh > 0 || parts.principalLow > 0;

  return (
    <>
      <td className="px-5 py-3 font-mono tabular-nums text-slate-900">
        {hasPrincipal ? formatINRRange(parts.principalLow, parts.principalHigh) : "—"}
      </td>
      <td className="px-5 py-3 font-mono tabular-nums text-slate-600">
        {hasCarrying ? formatINRRange(parts.carryingLow, parts.carryingHigh) : "—"}
      </td>
      <td className="px-5 py-3 font-mono tabular-nums font-medium text-slate-900">
        {valueHigh > 0 ? formatINR(valueHigh) : "—"}
      </td>
    </>
  );
}
